import React from 'react';
import { Form, Input, Button,Spin,Select,Switch } from 'antd';
import axios from 'axios'
import * as serverconfig from '../../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,UploadOutlined } from '@ant-design/icons';
import PhoneInput from 'react-phone-number-input'

var CryptoJS = require("crypto-js");
const { Option } = Select;

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;


var token= ''
var sacco= ''


class HubDetails extends React.Component {

  state = {
    name:'' ,  
    idtypeDescription:'',
    IDvaliditydays:0,
    datarequested:false,

    supervisor_name:'',
    District:'',
    districts:[],
    supervisor_phone:'',
    location_longitude:0,
    location_latitude:0,
    region:'',

    main_hub:false,
    is_ntrl_hub:false,

  }

  componentDidMount(){
    const hubID=this.props.match.params.hubID;

    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
    }else{
       sacco= ''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    //get the instance_id package here
    axios.get(serverconfig.backendserverurl+`/api/districts/`)
    .then(res => {
      this.setState({
        districts:res.data
      })
    })

    axios.get(`${serverconfig.backendserverurl}/api/collectionhubs/${hubID}`)
    .then(res => {  

        this.setState({name:res.data.name})
        this.setState({supervisor_name:res.data.supervisor_name})
        this.setState({supervisor_phone:res.data.supervisor_phone})

        this.setState({District:res.data.district})

        this.setState({location_latitude:res.data.location_latitude})
        this.setState({location_longitude:res.data.location_longitude})
        this.setState({region:res.data.region})
        this.setState({main_hub:res.data.main_hub})
        this.setState({is_ntrl_hub:res.data.is_ntrl_hub})

        this.setState({datarequested:false})

    })
  }


  //submit button pressed
  handleFormSubmit=(event) =>{
    this.setState({datarequested:true})
    const hubID=this.props.match.params.hubID;

    let form_data = new FormData();
    form_data.append('name', this.state.name);
    form_data.append('supervisor_name', this.state.supervisor_name);
    form_data.append('supervisor_phone', this.state.supervisor_phone);

    form_data.append('district', this.state.District);

    form_data.append('location_latitude', this.state.location_latitude);
    form_data.append('location_longitude', this.state.location_longitude);
    form_data.append('region', this.state.region);
    form_data.append('main_hub', this.state.main_hub);
    form_data.append('is_ntrl_hub', this.state.is_ntrl_hub);

    axios.put(serverconfig.backendserverurl+`/api/collectionhubs/${hubID}/`, form_data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  .then(res =>    
    this.setState({datarequested:false})
,    window.location.reload(false)
  )
  .catch(error => console.log(error))

  }

  handlenameChange= (e) => this.setState({ name: e.target.value});
  handleIDDescriptionChange= (e) => this.setState({ idtypeDescription: e.target.value});

  render(){

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return (
        <div>
    <Form
        onFinish={(event) => this.handleFormSubmit(event)}
    >
      <FormItem label="Hub Name"
     
      >
        <Input name="name"  placeholder="Put a name here." value={this.state.name} onChange={this.handlenameChange} />
      </FormItem>


      <FormItem label="Supervisor name"
      
      >
        <Input name="supervisor_name"  placeholder="Name here" value={this.state.supervisor_name} onChange={(val)=>{this.setState({supervisor_name:val.target.value})}} />
      </FormItem>

      <FormItem label= { <h6 style={{display:'flex'}} >Supervisor phone contact</h6>}                       
      >
         <PhoneInput
            countrySelectProps={{ unicodeFlags: true }}
            defaultCountry="UG"
            placeholder="Enter phone number"
            value={this.state.supervisor_phone} onChange={(val)=>{this.setState({supervisor_phone:val})}}/>
       </FormItem> 

     
      <FormItem label="District"    
      >
        <Select
          placeholder="Ug District"
          style={{  }} 
          value={this.state.District}
            onChange={(val)=>{this.setState({District:val})}} 
            showSearch
            optionFilterProp="children"
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onSearch={this.onSearch}
            >
          {this.state.districts.map(
            (dist)=>(
              <Option value={dist.district_name}>{dist.district_name} | {dist.region}</Option>
            ))}
        </Select>
      </FormItem>

    
      <FormItem label="Address latitude"    
      >
        <Input  type='number'  name="Address latitude"  placeholder="Latitude here" value={this.state.location_latitude} onChange={(val)=>{this.setState({location_latitude:val.target.value})}} />
      </FormItem>

      <FormItem label="Address longitude"    
      >
        <Input  type='number'  name="Address longitude"  placeholder="Longitude here" value={this.state.location_longitude} onChange={(val)=>{this.setState({location_longitude:val.target.value})}} />
      </FormItem>

        <FormItem 
          name="main_hub" 
          label="CPHRL Hub?" 
        >
          <Switch
              checked={this.state.main_hub}
              onChange={val=>{this.setState({main_hub:!this.state.main_hub})}}
              checkedChildren="ON"
              unCheckedChildren="OFF"
              />
      </FormItem>

      <FormItem 
          name="is_ntrl_hub" 
          label="NTRL Hub?" 
        >
          <Switch
              checked={this.state.is_ntrl_hub}
              onChange={val=>{this.setState({is_ntrl_hub:!this.state.is_ntrl_hub})}}
              checkedChildren="ON"
              unCheckedChildren="OFF"
              />
      </FormItem>


      <FormItem>
        <Button  type="primary" htmlType="submit">Update</Button>
      </FormItem>

      </Form>
        </div>
      );
    }
    
  }

}


export default HubDetails;



